<script setup lang="ts">
import { defineProps } from 'vue'
import { NIcon } from 'naive-ui';
import { ChevronLeftRound } from '@vicons/material'
import { getImgUrl } from '@/ts/helpers'

const props = defineProps({
  backRouteName: String,
  bannerImg: String,
  bannerText: String
})
</script>

<template>
  <div>
    <router-link v-if="backRouteName" class="simple-link style-normal flex-center" :to="{ name: backRouteName }">
      <n-icon>
        <chevron-left-round></chevron-left-round>
      </n-icon>
      Back
    </router-link>

    <div class="banner-image-container">
      <img v-if="bannerImg" class="banner-img" :src="getImgUrl(props.bannerImg)">

      <span v-if="bannerText" class="heading d1 banner-title text-white">
        {{ bannerText }}
      </span>
    </div>

    <slot name="short-description"></slot>
  </div>
</template>

<style lang="scss">
.banner-image-container {
  position: relative;

  .banner-title {
    left: 0;
    bottom: 0;
    width: 40%;
    position: absolute;
    padding: 0 0 35px 24px;
  }
}

.short-description {
  margin-top: 44px;
}
</style>